import ComingSoon from "../../../../components/soon/CommingSoon";

const Reports = () => {
return <ComingSoon/>;
};

export default Reports;
